import React from 'react'
import CloseUserAreaButton from '../shared/CloseUserAreaButton'
import s from './UserAreaAnonymous.less'
import welcomeUserAccount from './welcome-user-account.svg'
import UserLoginButton from '../UserLoginButton'
import { withUserNotConnected } from '../shared/withKeycloak'
import LogoMappyImg from '../../genericComponents/LogoMappyImg'

const UserAreaAnonymous = () => (
  <div className={s.root}>
    <CloseUserAreaButton />
    <div className={s.content}>
      <div className={s.defaultScreen}>
        <img src={welcomeUserAccount} width="164" height="152" loading="lazy" />
        <p className={s.title1}>
          Le compte <LogoMappyImg />
        </p>
        <p className={s.title2}>c’est gratuit !</p>
        <ul className={s.list}>
          <li>Des itinéraires personnalisés</li>
          <li>Des infos durée et coût plus précises</li>
          <li>Mes adresses favorites sur le site et l’appli</li>
        </ul>
        <UserLoginButton />
      </div>
    </div>
  </div>
)

export default withUserNotConnected(UserAreaAnonymous)
